import { render, staticRenderFns } from "./MsinToMsisdn.vue?vue&type=template&id=85806480&scoped=true"
import script from "./MsinToMsisdn.vue?vue&type=script&lang=js"
export * from "./MsinToMsisdn.vue?vue&type=script&lang=js"
import style0 from "./MsinToMsisdn.vue?vue&type=style&index=0&id=85806480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85806480",
  null
  
)

export default component.exports